import { ModalState, isModalOpen, unwrapModalData } from '../utils/modal';

import { Button } from '@release/ui/Button';
import { Icon } from '@release/ui/Icon';
import { Modal } from '@release/ui/Modal';
import { Typography } from '@release/ui/Typography';

export interface SuccessDialogProps {
  state: ModalState<{ message: string }>;
  onClose: () => void;
}
export const SuccessDialog: React.FC<SuccessDialogProps> = ({ state, onClose }) => {
  return (
    <Modal isOpen={isModalOpen(state)} onRequestClose={onClose}>
      <div className="flex flex-col items-center px-6 py-8">
        <Icon name="check-circle-filled" size="32" className="self-center fill-sem-d-icon-success" />
        <Typography weight="bold" className="mt-4 whitespace-pre-line text-center">
          {unwrapModalData(state)?.message}
        </Typography>
        <Button variant="secondary" label="閉じる" onClick={onClose} className="mt-6" />
      </div>
    </Modal>
  );
};
